<template>
  <div
    :class="{ 'dypolicy-container': true, 'rtl-style': (rtlLangs.includes(lang) && rtlLangs.includes(activeCode)) || rtlLangs.includes(activeCode) }"
  >
    <div v-show="lang" class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" :style="{ tran: activeCode === 'en' ? '0deg' : '180deg' }" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <img v-if="packageName === 'vava'" class="left-icon vava" src="./images/vava.webp" style="width: 93px" />
          <img v-if="packageName === 'joychat'" class="left-icon joyChat" src="./images/joyChat.webp" style="width: 118px" />
          <img v-if="packageName === 'echo'" class="left-icon echo" src="./images/echo.webp" style="width: 86px" />
          <!-- todo 其他包图片 -->
        </template>
        <template v-if="activeCode" #right>
          <div class="nav-right-actions">
            <CStatus class="lang-box" arrowType="deep" :statuslist="langList" :activeStatu="activeLang" @selectStatus="handleLangChange" />
            <img class="share-btn" src="./images/share.webp" alt="" @click="handleShare" />
          </div>
        </template>
      </van-nav-bar>
    </div>

    <div v-show="!isLoading" class="switch-tab" :style="`position: sticky; top: ${topBarHeight + 22}px; z-index: 99;`">
      <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.host }" @click.stop="handleSwitchTab(tabEnmu.host, true)">
        {{ hostPolicyDesc }}
      </div>
      <div class="tab" :class="{ 'active-tab': tabIndex == tabEnmu.agency }" @click.stop="handleSwitchTab(tabEnmu.agency, true)">
        {{ agentPolicyDesc }}
      </div>
    </div>

    <div v-for="item in currentPolicy" class="policy-content-box" style="max-width: 1400px !important">
      <div v-if="item.title" class="policy-title">{{ item.title }}</div>
      <div v-if="item.content" class="policy-text-box" v-html="item.content"></div>
    </div>

    <div class="policy-content-box" style="visibility: hidden; margin-bottom: 0">
      <div id="target-box" class="policy-text-box"></div>
    </div>

    <!-- <c-confirm :title="confirmTitle" :showDiaC="showDiaConfirm" :oneShow="true" /> -->
    <van-dialog v-model="showDiaConfirm" :showConfirmButton="false" :closeOnClickOverlay="false" @close="close">
      <div class="dialog">
        <div class="con" v-if="confirmTitle">{{ confirmTitle }}</div>
        <div class="btn" @click="diaConfirmClose">{{ $t('lang.BaseCommon.k039') }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiGetDyPolicyApi, apiGetDyPolicyPreviewApi } from '@/api/imee'
import CStatus from '@/components/CStatus'
import CConfirm from '@/components/CConfirm'

const tabEnmu = {
  host: 1,
  agency: 0,
}

// 对应 postcss.config.js 中的配置
function pxToRem(htmlContent) {
  if (htmlContent == null || typeof htmlContent !== 'string') {
    return htmlContent ?? ''
  }
  try {
    // 匹配标签内的属性值，如 style="width: 100px; ..."
    return htmlContent.replace(/(\bstyle\s*=\s*["'][^"']*?)(\d+)px([^"']*["'])/gi, (match, p1, p2, p3) => {
      const remValue = (parseInt(p2) / 37.5).toFixed(5)
      return `${p1}${remValue}rem${p3}`
    })
  } catch (e) {
    console.error('[DynamicPolicy] pxToRem', e)
    return htmlContent
  }
}

// 这是主播代理里面的的协议
export default {
  components: { CStatus, CConfirm },
  props: {},
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
      tabEnmu,
      lang: 'en',
      tabIndex: tabEnmu.host,
      // packageType 1: vava  2: joychat  3: echo
      packageType: 0,
      hostPolicyDesc: 'Hostess Policy',
      agentPolicyDesc: 'Agent Policy',
      langList: [
        // {
        //   id: 'English',
        //   text: 'English'
        // }
      ],
      activeLang: '',
      activeCode: '',
      agentPolicy: [],
      hostPolicy: [],
      currentPolicy: [],
      // 无效
      confirmTitle: '',
      showDiaConfirm: false,
      isLoading: false,
    }
  },
  methods: {
    handleBack() {
      this.goPrevious()
    },
    handleShare() {
      const description = this.tabIndex === tabEnmu.host ? this.hostPolicyDesc : this.agentPolicyDesc
      const address = this.getMatchAddress()
      const lang = this.activeCode || this.$route.query.language || 'en'
      const queryParts = [`language=${encodeURIComponent(lang)}`, `identity=${encodeURIComponent(String(this.tabIndex))}`]
      const url = `https://${address}/invite-dypolicy?${queryParts.join('&')}`

      this.$client.copyLink(`${description} # ${url}`, this.$t('lang.BaseCommon.k071'))

      try {
        shareIntent.postMessage(
          JSON.stringify({
            title: this.getShareTitle(),
            description,
            url,
          })
        )
      } catch (err) {
        console.log('try catch', err)
      }
    },
    getShareTitle() {
      const shareTitleMap = {
        echo: 'Echo - Live video chat',
        joychat: 'Joychat - Live video chat',
        joyu: 'Joyu - Live video chat',
        kiko: 'Kiko - Live video chat',
        vava: 'Vava - Live video chat',
        vibeo: 'Vibeo - Live video chat',
        whonow: 'WhoNow - Live video chat',
      }

      return shareTitleMap[this.packageName] || shareTitleMap.vava
    },
    handleLangChange(arg, item) {
      this.activeLang = item.text
      this.activeCode = item.id
      this.getBaseData(item.id || 'en', this.$route.query.id)
      const nextQuery = { ...this.$route.query, language: item.id }
      if (String(this.$route.query.language || '') !== String(item.id || '')) {
        this.$router.replace({ path: this.$route.path, query: nextQuery }).catch((err) => {
          if (err && err.name !== 'NavigationDuplicated') {
            console.error('[DynamicPolicy] router.replace', err)
          }
        })
      }
    },
    handleSwitchTab(arg, isClick) {
      this.tabIndex = arg
      this.currentPolicy = arg === tabEnmu.host ? this.hostPolicy : this.agentPolicy
      this.$nextTick(() => {
        this.resolveImage()
        this.resolveALink()
      })

      if (isClick) {
        const nextQuery = { ...this.$route.query, identity: this.tabIndex }
        if (String(this.$route.query.identity ?? '') !== String(this.tabIndex)) {
          this.$router.replace({ path: this.$route.path, query: nextQuery }).catch((err) => {
            if (err && err.name !== 'NavigationDuplicated') {
              console.error('[DynamicPolicy] router.replace', err)
            }
          })
        }
      }
    },
    getBaseData(lang) {
      const resolveData = (resData) => {
        if (resData.error) {
          if (resData.error.status == 758) {
            this.confirmTitle = resData.error.description
            this.showDiaConfirm = true
          }
          return
        }
        // 语言
        if (resData.languageSelectors && resData.languageSelectors.length) {
          const currentLang = resData.languageSelectors.find((item) => item.code === resData.selectedLanguage)
          if (currentLang) {
            this.activeLang = currentLang.showName || ''
            this.activeCode = currentLang.code || ''
          }
          // 无默认语言
          else {
            // 默认en
            const enLang = resData.languageSelectors.find((item) => item.code === 'en')
            if (enLang) {
              this.activeLang = enLang.showName || ''
              this.activeCode = enLang.code || ''
              this.handleLangChange(null, { text: enLang.showName, id: enLang.code })
            }
            return
          }
          this.langList = resData.languageSelectors.map((item) => {
            return {
              id: item.code,
              text: item.showName,
            }
          })
        }

        // tab
        this.agentPolicyDesc = resData.agentPolicyDesc
        this.hostPolicyDesc = resData.hostPolicyDesc

        // 处理内容
        const hostList = resData.hostPolicy || []
        const agentList = resData.agentPolicy || []
        hostList.forEach((policy) => {
          policy.content = pxToRem(policy.content)
        })

        agentList.forEach((policy) => {
          policy.content = pxToRem(policy.content)
        })

        // 内容
        this.agentPolicy = agentList
        this.hostPolicy = hostList

        if (this.$route.query.identity * 1 === tabEnmu.host) {
          this.handleSwitchTab(tabEnmu.host)
          return
        }
        if (this.$route.query.identity * 1 === tabEnmu.agency) {
          this.handleSwitchTab(tabEnmu.agency)
        }
      }

      const finishLoading = () => {
        this.isLoading = false
      }

      const handlePolicyResponse = (resData) => {
        try {
          resolveData(resData)
        } catch (e) {
          console.error('[DynamicPolicy] resolveData', e)
        } finally {
          finishLoading()
        }
      }

      this.isLoading = true

      // 预览
      if (this.$route.path === '/demo/invite-dypolicy') {
        apiGetDyPolicyPreviewApi(lang)
          .then(handlePolicyResponse)
          .catch((e) => {
            console.error('[DynamicPolicy] apiGetDyPolicyPreviewApi', e)
            finishLoading()
          })
        return
      }

      // 正式
      if (this.$route.path === '/invite-dypolicy') {
        apiGetDyPolicyApi(lang)
          .then(handlePolicyResponse)
          .catch((e) => {
            console.error('[DynamicPolicy] apiGetDyPolicyApi', e)
            finishLoading()
          })
        return
      }

      finishLoading()
    },
    resolveImage() {
      try {
        const dom = document.querySelector('#target-box')
        if (!dom) return
        const layout = dom.getBoundingClientRect()

        this.currentPolicy.forEach((item) => {
          if (!item.param) return
          try {
            const param = JSON.parse(item.param)
            if (param && param.length) {
              param.forEach((p) => {
                const img = document.getElementById(`${p.id}`)
                if (img) {
                  img.style.borderRadius = '12px'
                  if (p.width > layout.width * 0.5) {
                    img.style.width = '100%'
                    img.style.height = 'auto'
                  }
                }
              })
            }
          } catch (e) {
            console.error('[DynamicPolicy] resolveImage param', e)
          }
        })
      } catch (e) {
        console.error('[DynamicPolicy] resolveImage', e)
      }
    },
    resolveALink() {
      try {
        const aLinks = document.querySelectorAll('a')
        aLinks.forEach((item) => {
          item.addEventListener('click', () => {
            try {
              const url = item.getAttribute('href')
              item.setAttribute('href', '')
              if (url && url.indexOf('http') > -1) {
                try {
                  this.appAction('open_web_outside', `?url=${url}`)
                } catch (error) {
                  window.open(url, '_blank')
                }
              }
            } catch (e) {
              console.error('[DynamicPolicy] resolveALink click', e)
            }
          })
        })
      } catch (e) {
        console.error('[DynamicPolicy] resolveALink', e)
      }
    },
    diaConfirmClose() {
      this.showDiaConfirm = false
    },
    close() {
      this.showDiaConfirm = false
    },
  },
  created() {
    this.getBaseData(this.$route.query.language)
  },
  mounted() {
    this.$nextTick(() => {
      this.lang = this.$i18n.locale
    })
  },
}
</script>

<style lang="scss" scoped>
.dypolicy-container {
  background-image: linear-gradient(#e7e6fc, #b1adf6);
  min-height: 100vh;
  direction: ltr;

  .custom-nav-block {
    background: #ffffff;
    overflow: visible;

    ::v-deep .van-nav-bar {
      overflow: visible;
    }

    ::v-deep .van-nav-bar__title {
      font-family: var(--string-font);
      font-size: var(--fs-20);
      font-weight: var(--fw-900);
      line-height: var(--lh-title-24);
      color: #fff;
    }

    ::v-deep .van-nav-bar__left {
      left: 0;
      font-family: 'Inter-Regular';
      font-weight: bold;
      font-size: 17px;
      color: #ffffff;
      line-height: 20px;
    }

    ::v-deep .van-nav-bar__right {
      right: 0;
      padding: 0 !important;

      .nav-right-actions {
        display: flex;
        align-items: center;
        padding-right: 8px;

        .lang-box {
          position: relative;
          flex-shrink: 1;
          min-width: 0;
          max-width: calc(100vw - 180px);
          border-radius: 44px;
          background: #f6f6fe;
          display: flex;
          padding: 6px 12px;
          align-items: center;
          gap: 2px;
          box-sizing: border-box;

          .status {
            margin-left: 0;
            font-size: 14px;
            font-family: 'Inter-Medium', 'Inter-Regular';
            font-weight: 500;
            color: #666666;
            max-width: 100%;

            .status-active {
              display: flex;
              align-items: center;
              gap: 2px;
              min-width: auto;
              max-width: 100%;
              height: auto;
              padding: 0;
              background: transparent;
              border-radius: 0;
              color: #666666;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              > img {
                position: static;
                width: 16px;
                flex-shrink: 0;
              }
            }

            .status-list {
              right: 0;
              left: auto;
              min-width: 108px;
              max-width: min(280px, calc(100vw - 16px));
              box-sizing: border-box;
              z-index: 100;

              > div {
                white-space: normal;
                word-break: break-word;
                height: auto;
                min-height: 30px;
                line-height: 18px;
                padding: 6px 8px;
              }
            }
          }
        }

        .share-btn {
          width: 36px;
          height: 36px;
          padding-left: 4px;
          box-sizing: border-box;
          flex-shrink: 0;
          object-fit: contain;
          cursor: pointer;
        }
      }
    }
  }

  .switch-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0 24px;
    padding-top: 24px;
    padding-bottom: 6px;
    background-color: #e2e2fb;

    .tab {
      min-width: 136px;
      padding: 3px 10px;
      line-height: 26px;
      font-family: 'Roboto-Regular';
      font-size: 17px;
      color: #333333;
      text-align: center;

      &.active-tab {
        color: #333333;
        position: relative;
        font-weight: bolder;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: -6px;
          width: 35px;
          height: 2px;
          margin-left: -17.5px;
          background-color: #333333;
        }
      }
    }
  }

  .policy-content-box {
    width: 343px;
    margin: 0 auto 16px;
    background-color: #eaedff;
    border-radius: 16px;
    padding: 16px;

    .policy-title {
      font-family: 'Roboto-Regular';
      font-size: 20px;
      color: #a338fc;
      line-height: 24px;
    }

    .policy-text-box {
      background: #ffffff;
      border-radius: 16px;
      padding: 16px 12px;
      margin-top: 16px;
      overflow-x: auto;
      font-family: 'Roboto-Regular';
      line-height: 24px;
      text-align: left;
    }
  }

  .dialog {
    width: 100%;
    padding: 30px 20px;

    .con {
      width: 100%;
      margin: 0 0 20px;
      font-size: 16px;
      font-family: 'Inter-Regular';
      font-weight: 500;
      color: #333333;
      line-height: 26px;
      text-align: center;
      overflow: hidden;
      white-space: pre-wrap;
      font-style: normal;

      > span {
        color: red;
      }
    }

    .btn {
      width: 200px;
      padding: 10px 0;
      margin: 0 auto;
      white-space: wrap;
      text-align: center;
      background: #a338fc;
      border-radius: 20px;
      font-size: 16px;
      font-family: 'Inter-Regular';
      font-weight: 600;
      color: #ffffff;
    }
  }

  @media (min-width: 520px) {
    .policy-content-box {
      width: 90%;
    }
  }
}
</style>

<style lang="scss">
.dypolicy-container {
  .policy-text-box {
    em {
      font-style: italic;
    }

    table {
      table-layout: automatic;

      tbody {
        tr {
          td {
            font-family: 'Roboto-Regular';
            font-size: 15px;
            color: #333333;
            line-height: 18px;
            padding: 10px 6px;
            word-wrap: break-word;
            border: 1px solid #ededed;
          }

          th {
            font-family: 'Roboto-Regular';
            font-size: 14px;
            color: #b2b2b2;
            line-height: 18px;
            padding: 6px 6px;
            word-wrap: break-word;
            border: 1px solid #ededed;
            background-color: #e7e7e7;
          }
        }
      }
    }

    p,
    table tbody tr th,
    table tbody tr td,
    ul li,
    ol li {
      font-size: 15px;
      color: #333333;
      font-family: 'Inter-Tight';
      margin: 3px 0;
    }

    ul {
      li:has(> span) {
        span {
          &::before {
            width: 10px;
            height: 10px;
            font-size: 26px;
            display: inline-flex;
            align-items: center;
            content: '·';
            vertical-align: sub;
          }
        }
      }

      li:not(:has(> span)) {
        &::before {
          width: 10px;
          height: 10px;
          font-size: 26px;
          display: inline-flex;
          align-items: center;
          content: '·';
          vertical-align: sub;
        }
      }
    }

    ol {
      counter-reset: item-counter;

      li:has(> span) {
        span {
          &::before {
            content: counter(item-counter) '.';
            counter-increment: item-counter;
            padding-right: 7px;
          }
        }
      }

      li:not(:has(> span)) {
        &::before {
          content: counter(item-counter) '.';
          counter-increment: item-counter;
          padding-right: 7px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .dypolicy-container {
    .custom-nav-block {
      ::v-deep .van-nav-bar__left {
        img {
          transform: rotateY(0deg) !important;
        }

        .left-icon {
          transform: rotateY(0deg) !important;
        }
      }
    }

    .policy-content-box {
      * {
        direction: ltr !important;
      }
    }

    &.rtl-style {
      .policy-content-box {
        * {
          direction: rtl !important;
        }
      }
    }
  }
}
</style>
